var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95681 0.557353C8.32364 -0.185815 9.38339 -0.185815 9.75022 0.557353L11.7111 4.52981C11.8566 4.82466 12.1378 5.02912 12.4631 5.07668L16.8497 5.71784C17.6696 5.83768 17.9964 6.84552 17.4028 7.42368L14.2303 10.5137C13.9944 10.7435 13.8868 11.0746 13.9424 11.3991L14.6909 15.7634C14.8311 16.5803 13.9735 17.2033 13.2399 16.8175L9.31897 14.7555C9.02758 14.6023 8.67945 14.6023 8.38806 14.7555L4.46715 16.8175C3.73352 17.2033 2.87597 16.5803 3.01609 15.7634L3.7646 11.3991C3.82026 11.0746 3.7126 10.7435 3.47673 10.5137L0.304194 7.42368C-0.289399 6.84552 0.0373847 5.83768 0.857299 5.71784L5.24388 5.07667C5.56924 5.02912 5.85042 4.82466 5.99596 4.52981L7.95681 0.557353Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1093c550aaa15ba96cc30513ed2a8c60.svg";
export { ForwardRef as ReactComponent };